import React from 'react';

import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';
import { usePage } from '$contexts/page.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PartnershipCardsBlock}
 */
const PartnershipCards = ({
    backgroundColor,
    id,
    partners,
    text,
    title
}) => {
    const { page } = usePage();

    const bgColor = `bg-surface-panel-${backgroundColor}`;

    return (
        <section className={`col-wrapper-breakout ${bgColor} rounded-lg py-24`}>
            <h2 className='col-padding type-style-sans-h1 w-full sm:w-8/12 md:w-7/12'>
                {title}
            </h2>

            {text && (
                <p className='col-padding type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-6/12'>
                    {text}
                </p>
            )}

            <div className='flex flex-wrap mt-64 gap-y-8 md:gap-y-16'>
                {partners.map((partner, idx) => {
                    return (
                        <div
                            className='col-padding w-full sm:w-6/12 md:w-4/12'
                            key={partner.id}>
                            <div className='h-full bg-surface-raised p-16 rounded-lg'>
                                <p className='type-style-sans-h3-med'>
                                    {partner.title}
                                </p>

                                {partner.text && (
                                    <p className='type-style-sans-body mt-8'>
                                        {partner.text}
                                    </p>
                                )}

                                {partner.ctaLabel && (
                                    <Button
                                        as='a'
                                        className='mt-16 button-outcome'
                                        data-analytics-action='click'
                                        data-analytics-context={title}
                                        data-analytics-destination={formatLinkBlockToUrl(partner.ctaLink)}
                                        data-analytics-id={`${page?.id}_${id}_partnership_cards_cta_${idx}`}
                                        data-analytics-label={partner.ctaLabel}
                                        data-analytics-location='modules'
                                        data-analytics-module='partnership_cards_cta'
                                        href={formatLinkBlockToUrl(partner.ctaLink)}>
                                        {partner.ctaLabel}
                                    </Button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PartnershipCards;
